import React, { useState } from 'react';
import TagInput from '../../components/TagInput/TagInput';
import { MdClose } from 'react-icons/md'
import axiosInstance from '../../Utils/axiosInstance';


const AddEditNotes = ({ type, getAllNotes, data, onClose,showHandleToast }) => {

    const [title, setTitle] = useState(data?.title || "");
    const [content, setContent] = useState(data?.content || "");
    const [tag, setTag] = useState(data?.tags || []);
    const [error, setError] = useState("");

    const addNote = async () => {
        try {
            const res = await axiosInstance.post('/add-note', {
                title,
                content,
                tags:tag
            })

            if (res.data && res.data.note) {
                showHandleToast("Note Added Successfully")
                getAllNotes();
                onClose();
            }
        } catch (error) {
            if (
                error.response &&
                error.response.data &&
                error.response.data.message
            ) {
                setError(error.response.data.message)
            }
        }


    }
    const editNote = async () => {
        const noteId = data._id
        try {
            const res = await axiosInstance.put('/edit-note/'+ noteId , {
                title,
                content,
                tag
            })

            if (res.data && res.data.note) {
                showHandleToast("Note Edited Successfully")
                getAllNotes();
                onClose();
            }
        } catch (error) {
            if (
                error.response &&
                error.response.data &&
                error.response.data.message
            ) {
                setError(error.response.data.message)
            }
        }
    }



    const handleAddNote = (e) => {
        e.preventDefault();
        if (!title) {
            setError("Enter the Title");
            return;
        }
        if (!content) {
            setError("Enter the Content");
            return;
        }

        if (type == 'edit') {
            editNote();
        } else {
            addNote()
        }

        setError("");

    }
    return (

        <div className='relative  rounded-xl '  >
            <button
                onClick={onClose}
                className='w-10 h-10 rounded-full flex items-center justify-center absolute -top-3 -right-3 hover:bg-slate-50' >
                <MdClose className='text-xl text-slate-400' />
            </button>
            <div className="flex flex-col gap-2">
                <label className="font-bold  input-label">TITLE</label>
                <input
                    type="text"
                    className="text-md bg-slate-100 rounded-lg p-1  text-slate-950 outline-none"
                    value={title}
                    onChange={({ target }) => setTitle(target.value)}
                />
            </div>
            <div className='flex flex-col gap-2 mt-4' >
                <label className="font-bold input-label">CONTENT</label>
                <textarea
                    type="text"
                    className="text-md text-slate-950 bg-slate-100 p-2 rounded outline-none" rows={10}
                    value={content}
                    onChange={({ target }) => setContent(target.value)}
                />
            </div>

            <div className='mt-3' >
                <label className='input-label'>Tags</label>
                <TagInput tags={tag} setTags={setTag} />
            </div>

            {error && <p className='text-red-500 text-sm pt-4' >{error}</p>}
            <button className='btn bg-blue-600 hover:bg-blue-700 rounded-sm text-white w-full font-medium text-base mt-5 p-3' onClick={handleAddNote}>
                {type == 'edit' ? 'Update' : 'Add'}
            </button>
        </div>

    )
}

export default AddEditNotes
